import Vue from "vue";
import Vuetify from "vuetify/lib";
import { ClickOutside } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  directives: {
    ClickOutside,
  },
});

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#194FA2",
        secondary: "#26BEC8",
        hover: "#069EA8",
        success: "#0C9C59",
        info: "#2196F3",
        warning: "#D48D15",
        error: "#FF5252",
        // background: `radial-gradient(circle at 75% 25%, rgba(38, 190, 200, 0.04) 0%, rgba(255, 255, 255, 0) 50%),
        //              radial-gradient(circle at 25% 75%, rgba(128, 67, 246, 0.04) 0%, rgba(255, 255, 255, 0) 50%),
        //              #E4E4E4`,
        backgroundLight: "#ffffff",
        blackLight: "#595959",
        blackDark: "#10141A",
      },
      dark: {
        primary: "#194FA2",
        secondary: "#26BEC8",
        hover: "#069EA8",
        success: "#0C9C59",
        info: "#2196F3",
        warning: "#D48D15",
        error: "#FF5252",
        // background: `radial-gradient(circle at 75% 25%, rgba(38, 190, 200, 0.04) 0%, rgba(255, 255, 255, 0) 50%),
        //              radial-gradient(circle at 25% 75%, rgba(128, 67, 246, 0.04) 0%, rgba(255, 255, 255, 0) 50%),
        //              #E4E4E4`,
      },
    },
  },
});
